import { createAsyncAction } from 'stores/helpers';

export const fetchCustomerId = createAsyncAction<undefined, number | null, Error | null, undefined>(
  'configurator/getId'
);
